import {
  TcfEuV2, 
  UsCa, 
  UsCo, 
  UsCt, 
  UsDe,
  UsIa,
  UsUt, 
  UsVa,
  UsMt,
  UsNe,
  UsNh,
  UsNj,
  UsOr,
  UsTn,
  UsTx,
  UsFl } from '@iabgpp/cmpapi'

export function updateCMPColorado( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateColorado: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsCoV1Field.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsCoV1.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/CO/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Colorado%20Privacy%20Technical%20Specification.md

  let sections = cmpApi.getApplicableSections();

  if ( sections.indexOf( UsCo.ID) == -1 ) {
    sections.push( UsCo.ID )
    cmpApi.setApplicableSections(sections);
  }

  cmpApi.setFieldValue(UsCo.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsCo.NAME, 'SharingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsCo.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
  cmpApi.setFieldValue(UsCo.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsCo.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsCo.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
  if ( consentToAll ) {
    cmpApi.setFieldValue(UsCo.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsCo.NAME, 'KnownChildSensitiveDataConsents', 0); // 0 = not applicable
  cmpApi.setFieldValue(UsCo.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsCo.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsCo.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsCo.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsCo.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsCo.NAME, 'Gpc', 0);
}

export function updateCMPCalifornia( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateCalifornia: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/0..ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsCa.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/CA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20California%20Privacy%20Technical%20Specification.md


  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsCa.ID ) == -1 ) {
    sections.push( UsCa.ID );
    cmpApi.setApplicableSections(sections);
    cmpApi.setFieldValue(UsCa.NAME, 'Version', 1);
  }

  cmpApi.setFieldValue(UsCa.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
  cmpApi.setFieldValue(UsCa.NAME, 'SharingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsCa.NAME, 'SensitiveDataLimitUseNotice', 1);  // 1 = notice given

  cmpApi.setFieldValue(UsCa.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsCa.NAME, 'SharingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
  
  if ( consentToAll ) {
    cmpApi.setFieldValue(UsCa.NAME, 'SensitiveDataProcessing',  Array( 9 ).fill( 2 ) );
  }
  
  cmpApi.setFieldValue(UsCa.NAME, 'KnownChildSensitiveDataConsents', [0,0]); // 0 = not applicable
  cmpApi.setFieldValue(UsCa.NAME, 'PersonalDataConsents', consentToTargeting ? 2 : 1 );
  cmpApi.setFieldValue(UsCa.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsCa.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsCa.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsCa.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsCa.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsCa.NAME, 'Gpc', 0);
}

export function updateCMPConnecticut( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateConnecticut: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsCtField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsCt.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/CT/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Connecticut%20Privacy%20Technical%20Specification.md

  let sections = cmpApi.getApplicableSections();

  if ( sections.indexOf( UsCt.ID) == -1 ) {
    sections.push( UsCt.ID );
    cmpApi.setApplicableSections(sections);
  }

  cmpApi.setFieldValue(UsCt.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsCt.NAME, 'SharingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsCt.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
  cmpApi.setFieldValue(UsCt.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsCt.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsCt.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
  if ( consentToAll ) {
    cmpApi.setFieldValue(UsCt.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsCt.NAME, 'KnownChildSensitiveDataConsents', [0,0,0]); // 0 = not applicable
  cmpApi.setFieldValue(UsCt.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsCt.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsCt.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsCt.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsCt.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsCt.NAME, 'Gpc', 0);
}

export function updateCMPUtah( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateUtah: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsUtField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsUt.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/CT/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Utah%20Privacy%20Technical%20Specification.md

  let sections = cmpApi.getApplicableSections();

  if ( sections.indexOf( UsUt.ID) == -1 ) {
    sections.push( UsUt.ID );
    cmpApi.setApplicableSections(sections);
  }

  cmpApi.setFieldValue(UsUt.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsUt.NAME, 'SharingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsUt.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
  cmpApi.setFieldValue(UsUt.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsUt.NAME, 'SensitiveDataProcessingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsUt.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );  // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsUt.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
  if ( consentToAll ) {
    cmpApi.setFieldValue(UsUt.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsUt.NAME, 'KnownChildSensitiveDataConsents', 0); // 0 = not applicable
  cmpApi.setFieldValue(UsUt.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsUt.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsUt.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)
  
  // no GPC fields for Utah

}

export function updateCMPVirginia( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateVirginia: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsVaField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsVa.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsVa.ID) == -1 ) {
    sections.push( UsVa.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsVa.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsVa.NAME, 'SharingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsVa.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
  cmpApi.setFieldValue(UsVa.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsVa.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsVa.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
  if ( consentToAll ) {
    cmpApi.setFieldValue(UsVa.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsVa.NAME, 'KnownChildSensitiveDataConsents', 0); // 0 = not applicable
  cmpApi.setFieldValue(UsVa.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsVa.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsVa.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // no GPC fields for Virginia
}

export function updateCMPFlorida( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateFlorida: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsFlField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsFl.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsFl.ID) == -1 ) {
    sections.push( UsFl.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsFl.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsFl.NAME, 'ProcessingNotice', 0);  // 0 = Not applicable
  cmpApi.setFieldValue(UsFl.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
  cmpApi.setFieldValue(UsFl.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsFl.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsFl.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
  if ( consentToAll ) {
    cmpApi.setFieldValue(UsFl.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsFl.NAME, 'KnownChildSensitiveDataConsents', [0,0,0]); // 0 = not applicable
  cmpApi.setFieldValue(UsFl.NAME, 'AdditionalDataProcessingConsent', 0);  // 0 = not applicable, 1 = yes, 2 = no
  cmpApi.setFieldValue(UsFl.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsFl.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsFl.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // no GPC fields for florida
}

export function updateCMPDelaware( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateDelaware: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsDeField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsDe.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsDe.ID) == -1 ) {
    sections.push( UsDe.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsDe.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsDe.NAME, 'ProcessingNotice', 0);  // 0 = Not applicable
  cmpApi.setFieldValue(UsDe.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
  cmpApi.setFieldValue(UsDe.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsDe.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsDe.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out
  if ( consentToAll ) {
    cmpApi.setFieldValue(UsDe.NAME, 'SensitiveDataProcessing',  Array( 9 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsDe.NAME, 'KnownChildSensitiveDataConsents', Array( 5 ).fill( 0 )); // 0 = not applicable
  cmpApi.setFieldValue(UsDe.NAME, 'AdditionalDataProcessingConsent', 0);  // 0 = not applicable, 1 = yes, 2 = no
  cmpApi.setFieldValue(UsDe.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsDe.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsDe.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsDe.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsDe.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsDe.NAME, 'Gpc', 0);
}

export function updateCMPIowa( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateIowa: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsIaField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsIa.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsIa.ID) == -1 ) {
    sections.push( UsIa.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsIa.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsIa.NAME, 'ProcessingNotice', 0);  // 0 = Not applicable
  cmpApi.setFieldValue(UsIa.NAME, 'SaleOptOutNotice', 0);         // 1 = notice given
  cmpApi.setFieldValue(UsIa.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsIa.NAME, 'SensitiveDataOptOutNotice', 1);         // 1 = notice given
  cmpApi.setFieldValue(UsIa.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsIa.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out

  if ( consentToAll ) {
    cmpApi.setFieldValue(UsIa.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsIa.NAME, 'KnownChildSensitiveDataConsents', 0); // 0 = not applicable
  cmpApi.setFieldValue(UsIa.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsIa.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsIa.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsIa.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsIa.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsIa.NAME, 'Gpc', 0);
}

export function updateCMPMontana( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateMontana: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsMtField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsMt.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsMt.ID) == -1 ) {
    sections.push( UsMt.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsMt.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsMt.NAME, 'SharingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsMt.NAME, 'SaleOptOutNotice', 0);         // 1 = notice given
  cmpApi.setFieldValue(UsMt.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsMt.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsMt.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out

  if ( consentToAll ) {
    cmpApi.setFieldValue(UsMt.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsMt.NAME, 'KnownChildSensitiveDataConsents', Array( 3 ).fill( 0 ) ); // 0 = not applicable
  cmpApi.setFieldValue(UsMt.NAME, 'AdditionalDataProcessingConsent', 0);  // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsMt.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsMt.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsMt.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsMt.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsMt.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsMt.NAME, 'Gpc', 0);
}

export function updateCMPNebraska( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateNebraska: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsNeField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsNe.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsNe.ID) == -1 ) {
    sections.push( UsNe.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsNe.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsNe.NAME, 'ProcessingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsNe.NAME, 'SaleOptOutNotice', 0);         // 1 = notice given
  cmpApi.setFieldValue(UsNe.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsNe.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsNe.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out

  if ( consentToAll ) {
    cmpApi.setFieldValue(UsNe.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsNe.NAME, 'KnownChildSensitiveDataConsents', 0); // 0 = not applicable
  cmpApi.setFieldValue(UsNe.NAME, 'AdditionalDataProcessingConsent', 0);  // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsNe.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsNe.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsNe.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsNe.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsNe.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsNe.NAME, 'Gpc', 0);
}

export function updateCMPNewHampshire( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateNewHampshire: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsNhField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsNh.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsNh.ID) == -1 ) {
    sections.push( UsNh.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsNh.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsNh.NAME, 'ProcessingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsNh.NAME, 'SaleOptOutNotice', 0);         // 1 = notice given
  cmpApi.setFieldValue(UsNh.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsNh.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsNh.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out

  if ( consentToAll ) {
    cmpApi.setFieldValue(UsNh.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsNh.NAME, 'KnownChildSensitiveDataConsents',  Array( 3 ).fill( 0 ) ); // 0 = not applicable
  cmpApi.setFieldValue(UsNh.NAME, 'AdditionalDataProcessingConsent', 0);  // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsNh.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsNh.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsNh.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsNh.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsNh.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsNh.NAME, 'Gpc', 0);
}

export function updateCMPNewJersey( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateNewJersey: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsNjField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsNj.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsNj.ID) == -1 ) {
    sections.push( UsNj.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsNj.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsNj.NAME, 'ProcessingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsNj.NAME, 'SaleOptOutNotice', 0);         // 1 = notice given
  cmpApi.setFieldValue(UsNj.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsNj.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsNj.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out

  if ( consentToAll ) {
    cmpApi.setFieldValue(UsNj.NAME, 'SensitiveDataProcessing',  Array( 10 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsNj.NAME, 'KnownChildSensitiveDataConsents',  Array( 5 ).fill( 0 ) ); // 0 = not applicable
  cmpApi.setFieldValue(UsNj.NAME, 'AdditionalDataProcessingConsent', 0);  // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsNj.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsNj.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsNj.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsNj.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsNj.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsNj.NAME, 'Gpc', 0);
}

export function updateCMPOregon( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateOregon: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsOrField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsOr.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsOr.ID) == -1 ) {
    sections.push( UsOr.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsOr.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsOr.NAME, 'ProcessingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsOr.NAME, 'SaleOptOutNotice', 0);         // 1 = notice given
  cmpApi.setFieldValue(UsOr.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsOr.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsOr.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out

  if ( consentToAll ) {
    cmpApi.setFieldValue(UsOr.NAME, 'SensitiveDataProcessing',  Array( 11 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsOr.NAME, 'KnownChildSensitiveDataConsents',  Array( 3 ).fill( 0 ) ); // 0 = not applicable
  cmpApi.setFieldValue(UsOr.NAME, 'AdditionalDataProcessingConsent', 0);  // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsOr.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsOr.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsOr.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsOr.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsOr.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsOr.NAME, 'Gpc', 0);
}

export function updateCMPTennessee( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateTennessee: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsTnField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsTn.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsTn.ID) == -1 ) {
    sections.push( UsTn.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsTn.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsTn.NAME, 'ProcessingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsTn.NAME, 'SaleOptOutNotice', 0);         // 1 = notice given
  cmpApi.setFieldValue(UsTn.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsTn.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsTn.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out

  if ( consentToAll ) {
    cmpApi.setFieldValue(UsTn.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsTn.NAME, 'KnownChildSensitiveDataConsents',  0); // 0 = not applicable
  cmpApi.setFieldValue(UsTn.NAME, 'AdditionalDataProcessingConsent', 0);  // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsTn.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsTn.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsTn.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsTn.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsTn.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsTn.NAME, 'Gpc', 0);
}

export function updateCMPTexas( consentToAll, cmpApi, consentToSharing, consentToTargeting ) {
  console.log("LayerStateTexas: updateCMP() consentToAll=" + consentToAll );

  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsTxField.ts
  //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsTx.ts
  //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/VA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20Virginia%20Privacy%20Technical%20Specification.md
  
  let sections = cmpApi.getApplicableSections();
  
  if ( sections.indexOf( UsTx.ID) == -1 ) {
    sections.push( UsTx.ID );
    cmpApi.setApplicableSections(sections);
  }
  
  cmpApi.setFieldValue(UsTx.NAME, 'Version', 1);
  cmpApi.setFieldValue(UsTx.NAME, 'ProcessingNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsTx.NAME, 'SaleOptOutNotice', 0);         // 1 = notice given
  cmpApi.setFieldValue(UsTx.NAME, 'TargetedAdvertisingOptOutNotice', 1);  // 1 = notice given
  cmpApi.setFieldValue(UsTx.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
  cmpApi.setFieldValue(UsTx.NAME, 'TargetedAdvertisingOptOut', consentToTargeting ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out

  if ( consentToAll ) {
    cmpApi.setFieldValue(UsTx.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
  }
  cmpApi.setFieldValue(UsTx.NAME, 'KnownChildSensitiveDataConsents',  0); // 0 = not applicable
  cmpApi.setFieldValue(UsTx.NAME, 'AdditionalDataProcessingConsent', 0);  // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsTx.NAME, 'MspaCoveredTransaction', 2);  // 1 = yes, 2 = no
  cmpApi.setFieldValue(UsTx.NAME, 'MspaOptOutOptionMode', 0);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
  cmpApi.setFieldValue(UsTx.NAME, 'MspaServiceProviderMode', 0);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

  // todo: get GPC flag from browser and set GPC flag here...

  cmpApi.setFieldValue(UsTx.NAME, 'GpcSegmentType', 1);
  cmpApi.setFieldValue(UsTx.NAME, 'GpcSegmentIncluded', 0);
  cmpApi.setFieldValue(UsTx.NAME, 'Gpc', 0);
}
